/**
 * The Roundup — 中文文案。
 *
 * 用词纪律(规格书 §1、§10.1):
 *   允许:  hit / hitter / 约打 / 主人 / 今晚价格
 *   禁用:  课/教/陪练/训练/学员/学费/tutor/lesson
 *
 * 编辑时不得引入禁用词。docs/roundup-vocab.md 会跑 lint。
 */
export const roundup = {
  brand: "The Roundup",
  boardTitle: "The Roundup · 现在谁在?",
  tagline: "没搭子?去约打。有时间?去挂牌。",

  sections: {
    free: "免费约打",
    paid: "付费约打",
    empty: "现在还没人挂牌 —— 挂个牌,设个价。",
  },

  statuses: {
    off: "下线",
    free: "免费上线",
    paid: "付费挂牌",
  },

  actions: {
    hostHit: "挂牌接单",
    bookHit: "约打",
    findHit: "找搭子",
    goOffline: "下线",
    setRate: "设置价格",
    accept: "接单",
    decline: "谢绝",
    cancel: "取消",
    complete: "标记为已打",
    dispute: "反馈问题",
    review: "填写评价",
  },

  card: {
    tonightsRate: "价格",
    freeLabel: "免费",
    perHour: " / 小时",
    ratingVerified: "已认证",
    ratingProvisional: "待定级",
    recentPrice: "近期成交 {{low}}–{{high}}",
    sameGenderOnly: "仅同性别",
    completedOrders: "已完成 {{count}} 单",
    stars: "{{stars}} ({{count}} 评)",
  },

  hostingModal: {
    title: "挂牌接单",
    modeLabel: "模式",
    modeFree: "免费约打",
    modeFreeSub: "同水平免费,场地费 AA。",
    modePaid: "付费约打",
    modePaidSub: "自设价格,平台抽 20%。",
    rateLabel: "你的价格",
    ratePlaceholder: "最低 $15 / 小时",
    rateHelper: "每次上线现设,不做永久标价。",
    bioLabel: "简短介绍(可选)",
    bioPlaceholder: "一句话说说你的球风",
    areasLabel: "可打场地区域",
    areasPlaceholder: "如: Downtown, Southgate",
    expiresLabel: "自动下线时间",
    expiresTonight: "今天 23:59",
    sameGenderLabel: "仅接同性别订单",
    inSeasonGate: {
      title: "付费挂牌需 In-Season",
      body:
        "近 {{days}} 天需完成 {{min}} 场认证赛。你目前 {{played}} 场。",
      cta: "改成免费挂牌",
    },
    submit: "上线",
    saving: "正在上线…",
  },

  bookingModal: {
    title: "预约这一单",
    proposedTime: "什么时候?",
    proposedDate: "日期",
    proposedStart: "开始",
    proposedEnd: "结束",
    courtLabel: "球场",
    courtPlaceholder: "在哪里打?",
    noteLabel: "备注(可选)",
    notePlaceholder: "打个招呼、说说偏好(140字)",
    fee: "平台手续费 (20%)",
    total: "现在预授权金额",
    escrowNote: "卡先做预授权,对方接单且打完之后才结算。",
    submitFree: "发送请求",
    submitPaid: "预约并预授权",
    submitting: "发送中…",
  },

  order: {
    statusRequested: "等待 hitter 接单",
    statusConfirmed: "已确认 · 球场见",
    statusCompleted: "已打",
    statusCancelled: "已取消",
    statusExpired: "已过期(24 小时未响应)",
    statusDisputed: "争议处理中",
    autoCompleteHint: "预约时段结束后 24 小时自动完成。",
    contactUnlocked: "联系方式已解锁,见下方",
  },

  policies: {
    cancelFull: "开打前 12 小时以上可全额退。",
    cancelPartial: "12 小时内: 退你 50%,hitter 得 45%,平台 5%。",
    hitterCancel:
      "hitter 取消: 全额退给你。hitter 连续两次取消暂停挂牌 7 天。",
  },

  review: {
    prompt: "给这次约打评分",
    starsLabel: "星级",
    bodyLabel: "一句话 ({{n}}/140)",
    submit: "提交评价",
    skip: "跳过",
    window: "7 天内可评价。",
    onlyPaid: "仅付费单可评价。",
  },

  compliance: {
    nonTeaching: "Hitter 是陪你对打,不是教你。此非课程。",
    payoutTerms: "20% 平台抽成,无隐藏费用。",
    waiver: "预约即视为你同意 Acework 参赛协议。",
    courtRequired: "仅限公开球场 / 正规场馆,双方共同同意。",
  },

  founding: {
    badge: "Founding Hitter",
    tooltip: "种子 hitter · 联赛免费。",
    obligation: "Founding Hitter 每赛季至少打 3 场认证赛。",
  },
};
